export default __webpack_public_path__ + "static/media/icon-upload.27887589.svg";